import type { FieldFilter } from "@/lib/customFields";

export interface FilterPreset {
  id: string;
  name: string;
  filters: {
    searchQuery: string;
    selectedAssignees: string[];
    selectedStatuses: string[];
    selectedPriorities: string[];
    selectedAddedBys: string[];
    selectedTicketTypes?: string[];
    selectedFeatures?: string[];
    /** Optional so presets saved before teams existed still load. */
    selectedTeams?: string[];
    /** Optional so presets saved before pipelines existed still load (#9304). */
    selectedPipelines?: string[];
    /** Optional so presets saved before custom fields existed still load (#9399). By field id. */
    customFields?: Record<string, FieldFilter>;
  };
  /** Optional subsheet to activate when loading this view */
  subsheetId?: string | null;
  /** Optional sort option to apply when loading this view */
  sortOption?: string | null;
  createdAt: string;
}

export const PRESETS_STORAGE_KEY = "backlog-filter-presets";
export const MAX_PRESETS = 10;
